// extracted by mini-css-extract-plugin
export default {"mail_btn":"notices-table_mail_btn__PI4FH","type_tag":"notices-table_type_tag__e-PWO"};